import PropTypes from 'prop-types';
import React from 'react';
import { cn } from 'lib/utils';

const baseContainer =
  'w-full [&>*]:tracking-wide [&_input]:w-full [&_input]:border [&_input]:border-[1.5px] [&_input]:border-grey-lighter [&_input]:rounded-[5px] [&_input]:outline-none [&_input]:!outline-none [&_input]:py-3 [&_input]:px-4 [&_input]:text-base [&_input]:font-normal [&_input]:text-black [&_input]:block [&_input]:tracking-wide [&_input]:placeholder:text-grey-light [&_input]:focus:border-primary-darkened [&_input]:disabled:bg-transparent [&_p]:w-max [&_p]:font-semibold [&_p]:capitalize';

const compactOverrides =
  '[&_input]:border-0 [&_input]:py-0.5 [&_input]:px-2.5 [&_input]:text-grey [&_input]:disabled:py-0.5 [&_input]:disabled:px-0 [&_p]:text-[length:--font-size-body] [&_p]:leading-none [&_p]:m-0!';

const Input = React.forwardRef(function InputWithRef(
  {
    label,
    error,
    className,
    lightLabel,
    inLine,
    noSpacing,
    fixedWidth,
    compact,
    labelClassName,
    wrapValue = false,
    fullWidthLabel = false,
    ...inputProps
  },
  ref
) {
  const { value, disabled, placeholder, ...restInput } = inputProps;
  const showWrappedValue = Boolean(wrapValue && disabled);
  const hasError = Boolean(error);
  const errorMessage = typeof error === 'string' ? error : '';

  return (
    <div
      className={cn(
        baseContainer,
        noSpacing && 'w-auto',
        fixedWidth && 'w-[400px]',
        compact && compactOverrides,
        fullWidthLabel &&
          '[&>p]:w-full [&>p]:max-w-full [&>p]:min-w-0 [&>p]:whitespace-normal [&>p]:wrap-break-word',
        inLine && 'flex items-center [&_p]:min-w-[35%] [&_p]:mr-2.5',
        hasError &&
          'mb-1 **:text-semantic-danger [&_input]:text-semantic-danger [&_input]:placeholder:text-semantic-danger [&_input]:border [&_input]:border-semantic-danger',
        errorMessage &&
          '[&_span]:block [&_span]:w-full [&_span]:mt-1 [&_span]:bg-semantic-danger [&_span]:text-white [&_span]:px-1.5 [&_span]:py-0.5 [&_span]:rounded-[5px]',
        className
      )}
    >
      <p
        className={cn(
          'text-black',
          lightLabel &&
            '[&_p]:text-grey-light [&_p]:font-normal [&_p]:text-(length:--font-size-body)',
          labelClassName
        )}
      >
        {label}
      </p>
      {showWrappedValue ? (
        <div
          role='textbox'
          aria-readonly='true'
          className={cn(
            'min-w-0 w-full whitespace-normal wrap-break-word text-base font-normal tracking-wide text-grey',
            compact ? 'py-0.5 px-0' : 'py-3 px-4'
          )}
        >
          {value !== undefined && value !== '' ? value : placeholder || ''}
        </div>
      ) : (
        <input
          ref={ref}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          {...restInput}
        />
      )}
      {errorMessage && <span>{errorMessage}</span>}
    </div>
  );
});

Input.propTypes = {
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,
  lightLabel: PropTypes.bool,
  inLine: PropTypes.bool,
  noSpacing: PropTypes.bool,
  fixedWidth: PropTypes.bool,
  compact: PropTypes.bool,
  labelClassName: PropTypes.string,
  wrapValue: PropTypes.bool,
  fullWidthLabel: PropTypes.bool
};

export default Input;
